import {getFirstNameControlMeta, getLastNameControlMeta} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import classNames from 'classnames'
import React from 'react'
import c from '../../../classnames.scss'
import {Error} from '../../commons/error'
import {Label} from '../../commons/label'
import fs from '../../fields.scss'
import {NameProps} from './interfaces'
import s from './name.scss'

export const Name = ({firstName, lastName, control, disabled, t}: NameProps) => {
  const renderFirstName = () => {
    const {maxLength, label} = getFirstNameControlMeta(control)
    const {
      input: {value, onChange, onBlur},
      meta: {touched, error},
    } = firstName

    return (
      <div data-hook={touched && error ? DH.FORM_INVALID_FIELD : ''} className={s.wrapper}>
        <Label
          required
          classes={classNames({[fs.disabledCaption]: disabled})}
          dataHook={DH.FIRST_NAME_CAPTION}
          htmlFor="firstName"
          caption={label}
        />
        <input
          required
          className={classNames(c.formInputBorderColor, fs.input, {[c.formInputError]: touched && error})}
          data-hook={DH.FIRST_NAME_INPUT}
          type="text"
          id="firstName"
          value={value}
          maxLength={maxLength}
          disabled={disabled}
          onBlur={onBlur}
          onChange={onChange}
        />
        <Error dataHook={DH.FIRST_NAME_ERROR} error={touched && error && t(error)} />
      </div>
    )
  }

  const renderLastName = () => {
    const {maxLength, label} = getLastNameControlMeta(control)
    const {
      input: {value, onChange, onBlur},
      meta: {touched, error},
    } = lastName

    return (
      <div data-hook={touched && error ? DH.FORM_INVALID_FIELD : ''} className={s.wrapper}>
        <Label
          required
          classes={classNames({[fs.disabledCaption]: disabled})}
          dataHook={DH.LAST_NAME_CAPTION}
          htmlFor="lastName"
          caption={label}
        />
        <input
          required
          className={classNames(c.formInputBorderColor, fs.input, {[c.formInputError]: touched && error})}
          data-hook={DH.LAST_NAME_INPUT}
          type="text"
          id="lastName"
          value={value}
          maxLength={maxLength}
          disabled={disabled}
          onBlur={onBlur}
          onChange={onChange}
        />
        <Error dataHook={DH.LAST_NAME_ERROR} error={touched && error && t(error)} />
      </div>
    )
  }

  return (
    <div className={classNames(fs.field, s.container)}>
      {renderFirstName()}
      {renderLastName()}
    </div>
  )
}
